import {
  Box,
  Typography,
  useTheme,
  Card,
  Grid,
  CardContent,
} from "@mui/material";


const Hero: React.FC = () => {
  const theme = useTheme();
 
  return (
    <Box
      id="hero"
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "auto", // Full screen height
        px: theme.spacing(8),
      }}
    >
      <Card
        component="section"
        sx={{
          width: "100%",
          height: "60%",
          boxShadow: "none",
          borderRadius: 8,
          backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1)), url(/images/physio/hero.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          pl: theme.spacing(4),
          role: "img",
          "aria-label": "Physiotherapist assisting patient with rehabilitation exercises",
        }}
      >
        <CardContent
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Vertically center content
            alignItems: "flex-start", // Align to the left
            color: "white",
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              color: "white",
              fontWeight: "bold",
              width: { xs: "100%", sm: "100%", md: "60%" },
              fontSize: ["1.5rem", "2rem", "2.5rem", "3rem"]
            }}
          >
            Achieve balance in mind, body and soul.
          </Typography>
          <Typography variant="h6" sx={{ marginTop: 2, color: "white", fontSize: ["0.75rem", "1rem", "1.25rem", "1.5rem"] }}>
            At Drax Hall Physiotherapy & Rehab, we focus on holistic recovery by
            addressing the root causes of pain, not just symptoms. Our expert
            team uses evidence-based techniques to create personalized treatment
            plans that improve mobility, reduce pain, and enhance function,
            helping you lead a more active life. Through manual therapy,
            tailored exercises, and advanced technologies, we support long-term
            healing and wellness.
          </Typography>
        </CardContent>
      </Card>

      <Grid container spacing={3} sx={{ mt: 0.5 }} height={{xs: "150vh",  md: "50vh"}}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: "100%", // Make sure the card takes the full height of the grid item
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end", // Center the content vertically
              alignItems: "flex-start", // Center the content horizontally
              boxShadow: "none",
              p: 3, // Add padding inside the card
              borderRadius: 8,
              backgroundImage:
                "linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1)), url(https://cdn.mos.cms.futurecdn.net/WczdfBVdCBZS8L2ZFijL9U.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Typography variant="h6" color={"white"}>
              Improved Flexibility
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              height: "100%", // Make sure the card takes the full height of the grid item
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end", // Center the content vertically
              alignItems: "flex-start", // Center the content horizontally
              boxShadow: "none",
              p: 3, // Add padding inside the card
              borderRadius: 8,
              backgroundImage:
                "linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1)), url(https://img.freepik.com/free-photo/man-training-with-ball-full-shot_23-2149178002.jpg?t=st=1734200206~exp=1734203806~hmac=fb1eb834602e4fc0c95f7e6a28e37aa15e3a5f555bf3b26bb62fbc6827ad2e22&w=740)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Typography variant="h6" color={"white"}>
              Stress Reduction
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Hero;
